import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import useCreateWorkspaceDataContext from 'modules/CreateWorkspaceModal/CreateWorkspaceDataProvider/useCreateWorkspaceDataContext';
import { DefaultRoleTypesEnum } from 'modules/Workspaces/hooks/useCreateWorkspaceRole/utils';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { getWorkspaceInviteSchema } from 'utils/yup/schemas/validationSchemas';

export type InviteFormType = {
  invitees: string[];
  role: string | null;
};

const useWorkspaceInviteForm = () => {
  const { invitees } = useCreateWorkspaceDataContext();
  const { workspaceRoles } = useWorkspacesContext();

  const defaultRole = workspaceRoles.find(({ defaultRoleType }) => defaultRoleType === DefaultRoleTypesEnum.MEMBER);

  const form = useForm<InviteFormType>({
    mode: 'all',
    resolver: yupResolver(getWorkspaceInviteSchema()),
    defaultValues: {
      invitees: invitees || [],
      role: defaultRole?.id,
    },
  });

  return form;
};

export default useWorkspaceInviteForm;
